import { SxProps, Theme } from '@mui/material';

const userContainer: SxProps<Theme> = {
  padding: 2,
  marginY: 2,

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexDirection: {
    xs: 'column',
    sm: 'row',
  },
};

const stickySidebar = {
  position: 'sticky',
  top: '90px',
};

const userTextsAlign: SxProps<Theme> = {
  textAlign: {
    xs: 'center',
    sm: 'left',
  },
};

const checkinDateTextsAlign: SxProps<Theme> = {
  textAlign: {
    xs: 'center',
    sm: 'right',
  },
};

const questionsContainer: SxProps<Theme> = {
  padding: 2,
};

const feedbackContainer: SxProps<Theme> = {
  padding: 2,
  marginY: 2,
};

const styles = {
  userContainer,
  stickySidebar,
  userTextsAlign,
  checkinDateTextsAlign,
  questionsContainer,
  feedbackContainer,
};

export default styles;
